import { combineReducers } from 'redux';
import user from './user/user.js';
import nav from './nav/nav.js';
import workstation from './workstation/workstation.js';
import general from './general/general.js';
import popup from './popup/popup.js';
// import opc from './opc/opc.js';

const rootReducer = combineReducers({
  user,
  nav,
  workstation,
  general,
  popup,
  // opc
});

// const rootReducer = (initialState, state,action) => {
  
//     state = initialState;
// }

export default rootReducer;